import React from 'react';
import { Badge } from '@chakra-ui/react';
import { POKER_COLORS } from '../../theme/designSystem';

interface PokerBadgeProps {
  type: 'coins' | 'cash' | 'accent' | 'success' | 'danger';
  children: React.ReactNode;
}

const PokerBadge: React.FC<PokerBadgeProps> = ({ type, children }) => {
  const colorScheme = {
    coins: { bg: `${POKER_COLORS.gold}22`, color: POKER_COLORS.gold },
    cash: { bg: `${POKER_COLORS.darkGreen}22`, color: POKER_COLORS.darkGreen },
    accent: { bg: `${POKER_COLORS.cyan}22`, color: POKER_COLORS.cyan },
    success: { bg: `${POKER_COLORS.darkGreen}22`, color: POKER_COLORS.darkGreen },
    danger: { bg: `${POKER_COLORS.darkRed}22`, color: POKER_COLORS.darkRed },
  };

  return (
    <Badge
      {...colorScheme[type]}
      px={3}
      py={1}
      borderRadius="4px"
      fontWeight="bold"
      fontSize="xs"
    >
      {children}
    </Badge>
  );
};

export default PokerBadge;